<template>
	<div class="box__btn box__btn_wrap" v-if="work.blocked != '1'">
		<div @click="appointment(work)" class="box__btn_doc-clinic" :class="{'gray': work.can == 'no'}">
			<p v-if="work.can == 'yes'">Быстрая запись</p>
			<p v-else-if="work.can == 'by_request'">Оставить заявку</p>
			<p v-else-if="work.can == 'no'" class="gray">Запись по телефону</p>
			<p v-else>Оставить заявку</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CreateVisitButton",
		props: ['work', 'appointment']
	}
</script>



// WEBPACK FOOTER //
// CreateVisitButton.vue?cfd1dde0